import { maybeSoftRedirect } from '@/core/navigation/redirect.service';
import { LinkModel } from '@/types/B2BcontentServerContract';

export default (response) => {
    const shouldRedirect = (response.data && response.headers.redirect === 'true');
    const replace = response.headers.replace === 'true';

    if (shouldRedirect) {
        const redirectLink:LinkModel = response.data.link;

        if (redirectLink?.url) {
            maybeSoftRedirect(redirectLink, replace);
        }

        throw new RedirectError();
    }
    return response;
};

export class RedirectError extends Error {
}
